import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import PositionProductList from '../PositionProductList';
import Dialog from '@afosto/app-components-react/Dialog';
import Icon from '@afosto/app-components-react/Icon';

const LocationPositionDialog = ({ title, isOpen, onClose, locationPosition }) => (
  <Dialog open={isOpen} onClose={onClose} fullScreen>
    <AppBar color="transparent" position="static" elevation={0}>
      <Toolbar>
        <Typography variant="h6">{title}</Typography>
        <IconButton
          edge="end"
          color="inherit"
          onClick={onClose}
          aria-label="close"
          style={{ marginLeft: 'auto' }}
        >
          <Icon icon={['fal', 'times']} />
        </IconButton>
      </Toolbar>
    </AppBar>
    <Box px={2} py={1}>
      <PositionProductList locationPosition={locationPosition} />
    </Box>
  </Dialog>
);

LocationPositionDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  locationPosition: PropTypes.object,
  title: PropTypes.string,
};

LocationPositionDialog.defaultProps = {
  isOpen: false,
  onClose: undefined,
  locationPosition: undefined,
  title: '',
};

export default LocationPositionDialog;
